<template>
  <div class="llra-wrap">
    <modal
      name="addLuckyRunner"
      @before-close="onClose"
      class="addLuckyRunner llra-modal"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      width="90%"
      :maxWidth="560"
    >
      <div class="llra-dialog">
        <div class="llra-dialog-header">
          <div class="llra-dialog-header-left">
            <span class="llra-dialog-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 7h-3V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H4"/>
                <path d="M5 7l1 14h12l1-14"/>
                <path d="M12 11v6"/>
                <path d="M9 14h6"/>
              </svg>
            </span>
            <div>
              <h2 class="llra-dialog-title">Add Lucky LiveRunner</h2>
              <p class="llra-dialog-sub">Create a gift record for a race participant</p>
            </div>
          </div>
          <button class="llra-close-btn" type="button" title="Close" @click="$modal.hide('addLuckyRunner')">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        <div class="llra-dialog-body">
          <div class="llra-id-grid">
            <div class="llra-field">
              <label class="llra-label">Race Id</label>
              <input class="llra-input" v-model="luckyRunnerData.raceId" @change="changeHandle">
            </div>
            <div class="llra-field">
              <label class="llra-label">Runner Id</label>
              <input class="llra-input" v-model="luckyRunnerData.runnerId" @change="changeHandle">
            </div>
          </div>
          <p class="llra-error" v-if="invalidError">{{invalidMsg}}</p>
          <div class="llra-field">
            <label class="llra-label">Sent</label>
            <div class="llra-date-field">
              <date-field v-model="luckyRunnerData.presentSentDate" name="presentSentDate">
              </date-field>
            </div>
          </div>
          <div class="llra-field">
            <label class="llra-label">What</label>
            <input class="llra-input" v-model="luckyRunnerData.presentContent">
          </div>
          <div class="llra-field">
            <label class="llra-label">Note</label>
            <textarea class="llra-textarea" v-model="luckyRunnerData.note"></textarea>
          </div>
        </div>

        <div class="llra-dialog-footer">
          <button class="llra-cancel-btn" type="button" @click="$modal.hide('addLuckyRunner')">Cancel</button>
          <button class="llra-save-btn" type="button" v-on:click="Save()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
              <polyline points="17 21 17 13 7 13 7 21"/>
              <polyline points="7 3 7 8 15 8"/>
            </svg>
            Save
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import RacesService from "../../../services/races"
import LuckyLiveRunnerService from "../../../services/luckyLiveRunner"
import RunnersByRaceService from "../../../services/runnersByRace"
import DateField from '@/components/Forms/DateField'

export default {
  name: "add-lucky-live-runner",
  data: () => ({
   luckyRunnerData:{
      "raceId":'',
      "runDate": "",
      "runName": "",
      "trainerName": "",
      "runStartTime": "",
      "runnerId": '',
      "runnerName": "",
      "presentSentDate": "",
      "presentContent": "",
      "note": ''
    },
    invalidError:false,
    invalidMsg:''
  }),
  props: {
    show: false
  },
  methods: {
    changeHandle(){
      this.invalidError=false
      this.invalidMsg=""
    },
    onClose() {
      //EventBus.$emit('date','true')
      this.luckyRunnerData={
      "raceId":'',
      "runDate": "",
      "runName": "",
      "trainerName": "",
      "runStartTime": "",
      "runnerId": '',
      "runnerName": "",
      "presentSentDate": "",
      "presentContent": "",
      "note": ''
    }
      this.$emit("closed", true)
    },
    openAddModal() {
      //this.luckyRunnerData.presentSentDate=""
      this.showError(false,"")
      this.$modal.show('addLuckyRunner')
    },
    showError(error,msg){
      this.invalidError=error
      this.invalidMsg=msg
    },
    Save() {
      var that = this
      if(this.luckyRunnerData.raceId!='' && this.luckyRunnerData.runnerId!=''){
        RacesService.get(this.luckyRunnerData.raceId).then((response) => {
          var raceData = response.data
          this.showError(false,"")
          that.luckyRunnerData.runDate= raceData.date.split("T")[0]
          that.luckyRunnerData.runName= raceData.name
          that.luckyRunnerData.trainerName=raceData.trainer.firstName
          that.luckyRunnerData.runStartTime= raceData.date.split("T")[1].split(":")[0] +":"+ raceData.date.split("T")[1].split(":")[1]
          that.luckyRunnerData.raceDateTime= raceData.date

          RunnersByRaceService.getByRunnerId(that.luckyRunnerData.runnerId).then(async (resp)=>{
            var runnerData = resp.data
            this.showError(false,"")
            that.luckyRunnerData.runnerName= runnerData.runner.firstName
            console.log("this.luckyRunnerData---",that.luckyRunnerData)
            LuckyLiveRunnerService.create(that.luckyRunnerData).then(response => {
              //this.$emit('saved', response.data)
              this.showError(false,"")
              this.$emit('saved')
              this.$modal.hide('addLuckyRunner')            
            }).catch(error => {
              console.log("err---",error)
              this.showError(true,error.data.description)
              //this.$modal.hide('addLuckyRunner')
            }) 
          }).catch(error => {
            console.log("err---",error)
            this.showError(true,"Invalid RunnerId !") 
          })
          
        }).catch(error => {
            console.log("err---",error) 
            this.showError(true,"Invalid RaceId !") 
        })  
      }else{
        this.luckyRunnerData.raceId==''?this.showError(true,"Invalid RaceId !"):this.showError(true,"Invalid RunnerId !")
      }

               
    }
  },
  created() {
    //this.$watch("show", function(val) {})
  },

  watch: {
    show(oldVal, newVal) {
      if (this.show) {
        this.openAddModal()
      }
    }
  },
  components: {
    DateField
  }
}
</script>
<style>
.llra-modal .sweet-modal {
  border: 1px solid #e8e8ed;
  border-radius: 14px;
  box-shadow: 0 18px 50px rgba(26, 26, 46, 0.18);
  overflow: hidden;
}

.llra-modal .sweet-content {
  padding: 0;
}

.llra-dialog {
  background: #fff;
}

.llra-dialog-header {
  align-items: center;
  border-bottom: 1px solid #f0f0f5;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding: 1.25rem 1.75rem;
}

.llra-dialog-header-left {
  align-items: center;
  display: flex;
  gap: 12px;
  min-width: 0;
}

.llra-dialog-icon {
  align-items: center;
  background: #f0effe;
  border-radius: 10px;
  color: #5b4fcf;
  display: inline-flex;
  flex: 0 0 36px;
  height: 36px;
  justify-content: center;
  width: 36px;
}

.llra-dialog-title {
  color: #1a1a2e;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0;
}

.llra-dialog-sub {
  color: #8a8a9a;
  font-size: 12px;
  line-height: 1.35;
  margin: 4px 0 0;
}

.llra-close-btn {
  align-items: center;
  background: #fff;
  border: 1px solid #e8e8ed;
  border-radius: 8px;
  color: #8a8a9a;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 30px;
  height: 30px;
  justify-content: center;
  transition: all 0.18s ease;
  width: 30px;
}

.llra-close-btn:hover {
  border-color: #f2b8b5;
  color: #c0392b;
}

.llra-dialog-body {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  padding: 1.5rem 1.75rem;
}

.llra-id-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.llra-field {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.llra-label {
  color: #1a1a2e;
  font-size: 12px;
  font-weight: 600;
  margin: 0;
}

.llra-input,
.llra-textarea,
.llra-date-field input {
  background: #fafafa;
  border: 1px solid #e8e8ed;
  border-radius: 8px;
  color: #1a1a2e;
  font-size: 14px;
  line-height: 1.4;
  outline: none;
  padding: 0 12px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
  width: 100%;
}

.llra-input,
.llra-date-field input {
  height: 40px;
}

.llra-textarea {
  min-height: 96px;
  padding-bottom: 10px;
  padding-top: 10px;
  resize: vertical;
}

.llra-input:focus,
.llra-textarea:focus,
.llra-date-field input:focus {
  border-color: #5b4fcf;
  box-shadow: 0 0 0 3px rgba(91, 79, 207, 0.12);
}

.llra-error {
  color: #c0392b;
  font-size: 12px;
  line-height: 1.35;
  margin: -5px 0 0;
}

.llra-dialog-footer {
  align-items: center;
  border-top: 1px solid #f0f0f5;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 1rem 1.75rem 1.5rem;
}

.llra-cancel-btn,
.llra-save-btn {
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  font-size: 13px;
  font-weight: 600;
  gap: 7px;
  height: 36px;
  justify-content: center;
  padding: 0 18px;
  transition: all 0.18s ease;
}

.llra-cancel-btn {
  background: #fff;
  border: 1.5px solid #e0e0ea;
  color: #5b4fcf;
}

.llra-cancel-btn:hover {
  border-color: #5b4fcf;
}

.llra-save-btn {
  background: #5b4fcf;
  border: none;
  color: #fff;
}

.llra-save-btn:hover {
  background: #4338ca;
}

@media (max-width: 520px) {
  .llra-dialog-header,
  .llra-dialog-body,
  .llra-dialog-footer {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .llra-id-grid {
    grid-template-columns: 1fr;
  }

  .llra-dialog-footer {
    align-items: stretch;
    flex-direction: column-reverse;
  }

  .llra-cancel-btn,
  .llra-save-btn {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// AddLuckyLiveRunner.vue?69c0d6ac